import React, { memo } from 'react';
import dynamic from 'next/dynamic';
import cn from 'classnames';

/* Components */
import ServicePriceOriginal from './ServicePriceOriginal';

/* Hooks */
import { useBrandingLogo } from '@integrations/partners/branding/useBranding.selector';

import { SkuExtended } from 'types/sku.types';

import styles from './serviceprice.module.scss';

const ServicePriceMember = dynamic(() => import('./ServicePriceMember'), { ssr: false });
const ServicePriceBranded = dynamic(() => import('./ServicePriceBranded'), { ssr: false });

type ServicePriceProps = {
  sku: SkuExtended;
  className?: string;
  sm?: boolean;
  onInfo: BaseAnyFunction;
  showFixedPrice?: boolean;
  linethroughPrice?: boolean;
};

const ServicePrice = ({ sku, onInfo, className, sm, showFixedPrice, linethroughPrice }: ServicePriceProps) => {
  let Price: React.ComponentClass<any> | React.FunctionComponent<any> = ServicePriceOriginal;
  const originalPrice = sku.prices.price;
  const noSavings = sku.prices.memberPrice === originalPrice;
  const logo = useBrandingLogo();

  if (sku.showMemberPrice && !noSavings) {
    Price = logo ? ServicePriceBranded : ServicePriceMember;
  }
  return (
    <div className={cn(styles.price, { [styles.sm]: sm }, className)}>
      <Price brandLogo={logo} sku={sku} sm={sm} onInfoClick={onInfo} showFixedPrice={showFixedPrice} linethroughPrice={linethroughPrice} />
    </div>
  );
};

export default memo(ServicePrice);
